import { useEffect, useState } from "react";
import { useLocation } from "react-use";

const useMemberPlanState = (members) => {

  const { pathname } = useLocation();

  const [selectedMember, setSelectedMember] = useState();

  useEffect(() => {
    const index = pathname.lastIndexOf("pdp/") + 4;
    const planUuid = pathname.substring(index).split("?")[0].replace("/", "");

    const member = members.find(m => planUuid === m?.development_plan?.uuid);
    if (member) {
      setSelectedMember(member);
    }
  }, [members, pathname]);

  const isMemberSelected = (member) => {
    const selectedPlan = selectedMember?.development_plan;
    const plan = member?.development_plan;
    return selectedPlan?.uuid === plan?.uuid;
  }

  return { members, selectedMember, isMemberSelected };
}

export default useMemberPlanState;
